module.exports = __webpack_public_path__ + "img/C4.a80bcbea.jpg";